(function () {
  'use strict';

  // Shopify storefront search is OR-based: /search?q=blue+double+breasted
  // returns every product matching ANY term (491 hits for a ~30-product intent)
  // and orders them by its own relevance model, so a "Navy …" item can outrank
  // the literal "Blue Double Breasted …" one. There is no storefront parameter
  // that turns it into AND, so the theme re-ranks what Shopify already sent:
  // items matching MORE of the typed tokens move up. Nothing is filtered out
  // and pagination is untouched — only the order inside the loaded page.
  //
  // Also exposed as window.viossiSearchRank so the predictive overlay
  // (snippets/search-overlay.liquid) scores /search/suggest.json payloads with
  // exactly the same rules.

  // Interchangeable words shoppers type. Deliberately tiny: real synonym
  // management belongs in Shopify Search & Discovery, not in the theme.
  var SYNONYMS = {
    navy: ['blue'],
    blue: ['navy'],
    grey: ['gray'],
    gray: ['grey']
  };

  // Words that carry no filtering signal in a menswear query.
  var STOPWORDS = {
    a: 1, an: 1, the: 1, and: 1, for: 1, with: 1, of: 1, in: 1,
    men: 1, mens: 1, man: 1, s: 1
  };

  // Field weights, strongest first. The title is what the shopper reads, so it
  // wins; the product type is broad ("Double Breasted Vests" is also the type of
  // a single-breasted vest in this catalogue) and tags are broader still, though
  // colour and fit only live there ("Color_Sky-Blue", "slim-fit"). A synonym hit
  // scores below any direct hit, so an exact "Blue …" always beats a "Navy …".
  var W_TITLE = 1;
  var W_TYPE = 0.85;
  var W_TAG = 0.7;
  var W_SYNONYM = 0.55;

  function normalize(str) {
    return String(str == null ? '' : str)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function tokenize(str) {
    var words = normalize(str).split(' ');
    var out = [];
    for (var i = 0; i < words.length; i++) {
      var word = words[i];
      if (!word || word.length < 2 || STOPWORDS[word]) continue;
      if (out.indexOf(word) === -1) out.push(word);
    }
    return out;
  }

  // A haystack word matches a token when it is equal, or when one is a prefix of
  // the other by at most two characters — enough for plurals ("loafer" ↔
  // "Loafers", "tie" ↔ "Ties") without pulling in a stemmer. The shorter side
  // must still be 3+ characters, otherwise stray fragments would match ("red"
  // would hit the "re" of a hyphenated word).
  var MIN_PREFIX = 3;

  function wordsMatch(words, token) {
    for (var i = 0; i < words.length; i++) {
      var word = words[i];
      if (word === token) return true;
      var shorter = word.length < token.length ? word : token;
      var longer = word.length < token.length ? token : word;
      if (shorter.length < MIN_PREFIX) continue;
      if (longer.length - shorter.length <= 2 && longer.indexOf(shorter) === 0) return true;
    }
    return false;
  }

  // Sum over query tokens of the best-weighted field the token was found in.
  // A product matching every token scores tokens.length; partial matches land
  // strictly below, which is the whole point — Shopify's OR result set gets
  // ordered by how completely each item answers the query.
  function score(tokens, title, type, tagText) {
    var fields = [
      [normalize(title).split(' '), W_TITLE],
      [normalize(type).split(' '), W_TYPE],
      [normalize(tagText).split(' '), W_TAG]
    ];
    var total = 0;
    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];
      var alts = SYNONYMS[token] || [];
      var hit = 0;
      for (var f = 0; f < fields.length && hit === 0; f++) {
        if (wordsMatch(fields[f][0], token)) {
          hit = fields[f][1];
        }
      }
      if (hit === 0) {
        for (var f2 = 0; f2 < fields.length && hit === 0; f2++) {
          for (var j = 0; j < alts.length; j++) {
            if (wordsMatch(fields[f2][0], alts[j])) {
              hit = W_SYNONYM;
              break;
            }
          }
        }
      }
      total += hit;
    }
    return total;
  }

  // Descending by score, stable: equal scores keep Shopify's own ordering.
  // Array.prototype.sort is only guaranteed stable in newer engines, hence the
  // explicit index tie-break.
  function rank(items, scoreOf) {
    var decorated = [];
    var i;
    for (i = 0; i < items.length; i++) {
      decorated.push({ item: items[i], index: i, score: scoreOf(items[i]) });
    }
    decorated.sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      return a.index - b.index;
    });
    var out = [];
    for (i = 0; i < decorated.length; i++) out.push(decorated[i].item);
    return out;
  }

  window.viossiSearchRank = {
    tokenize: tokenize,
    score: score,
    rank: rank
  };

  // --- /search results page: re-order the cards of the loaded page ----------
  function rerankGrid() {
    var grid = document.querySelector('[data-search-rerank]');
    if (!grid) return;

    // An explicit sort (price, title, …) is the shopper's own choice and must
    // survive untouched; only Shopify's "relevance" order may be improved.
    var sort = grid.getAttribute('data-search-sort') || 'relevance';
    if (sort !== 'relevance') return;

    // Single-token queries have nothing to disambiguate — every result matches
    // the only token, so re-ranking would just churn the DOM.
    var tokens = tokenize(grid.getAttribute('data-search-terms') || '');
    if (tokens.length < 2) return;

    var cards = Array.prototype.slice.call(grid.children);
    if (cards.length < 2) return;

    // Cards carry no tags in their markup, so the page scores on title + type.
    // Shipping a tag index alongside the grid was measured and dropped: in this
    // catalogue tags only restate the title colour, so it changed no ordering
    // while adding kilobytes to every search page. The overlay does use tags —
    // the predictive API hands them over for free.
    var ordered = rank(cards, function (card) {
      var title = card.querySelector('.pcard-title');
      var type = card.querySelector('.pcard-type');
      return score(tokens, title ? title.textContent : '', type ? type.textContent : '', '');
    });

    // Move every card through a fragment so the grid reflows once, not N times.
    var frag = document.createDocumentFragment();
    for (var i = 0; i < ordered.length; i++) frag.appendChild(ordered[i]);
    grid.appendChild(frag);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rerankGrid);
  } else {
    rerankGrid();
  }
})();
